import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';

import Box from '@zenbusiness/zui/Box';

import { FIELD_NAMES } from '#client/components/AddressFieldset';
import { buildFieldName } from '#client/utils/form';

function SummaryView({ sectionKey }) {
  const { watch } = useFormContext();

  // Watch form fields to display in the complete state
  const address1 = watch(buildFieldName(FIELD_NAMES.ADDRESS_1, sectionKey));
  const address2 = watch(buildFieldName(FIELD_NAMES.ADDRESS_2, sectionKey));
  const city = watch(buildFieldName(FIELD_NAMES.CITY, sectionKey));
  const state = watch(buildFieldName(FIELD_NAMES.STATE, sectionKey));
  const postalCode = watch(buildFieldName(FIELD_NAMES.POSTAL_CODE, sectionKey));

  const cityStatePostalCode = `${city}, ${state} ${postalCode}`;

  return (
    <>
      <Box component="span">{address1}</Box>
      {address2 && <Box component="span">{address2}</Box>}
      <Box component="span">{cityStatePostalCode}</Box>
    </>
  );
}

SummaryView.propTypes = {
  sectionKey: PropTypes.string.isRequired
};

export default SummaryView;
